"use client";

import React from "react";
import CommonCard from "../commonCard/CommonCard";
import "./style.css";

interface Post {
  id: string;
  title: string;
  excerpt?: string;
  image: string;
  imageAlt: string;
  url: string;
  author: string;
  title_slug: string;
  category_name: string;
  category_slug: string;
  category_color: string;
  sub_category_name: string;
  sub_category_slug: string;
  sub_category_color: string;
  created_at: string;
  author_username: string;
  author_slug: string;
  summary: string;
  date: string;
  tags: string;
  featured: boolean;
  isPrivate?: boolean;
}

interface FeaturedArticlesProps {
  featuredPosts: Post[];
}

/* =========================
   Icons (Theme-aware)
========================= */

const FeaturedIcon: React.FC = () => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ stroke: "var(--muted-foreground)" }}
  >
    <path
      d="M4.58898 10.5316L9.47815 2.84862C9.7467 2.4266 10.4 2.61683 10.4 3.11705V8.50002C10.4 8.55525 10.4447 8.60002 10.5 8.60002H13.9396C14.3442 8.60002 14.5812 9.05537 14.3493 9.38676L9.50959 16.3006C9.22925 16.7011 8.59998 16.5027 8.59998 16.0138V11.4C8.59998 11.3448 8.5552 11.3 8.49998 11.3H5.01081C4.61627 11.3 4.37716 10.8644 4.58898 10.5316Z"
      strokeWidth={1.4}
    />
  </svg>
);

const PrivateIcon: React.FC = () => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ stroke: "var(--muted-foreground)" }}
  >
    <path
      d="M5.45001 7.10005V6.41433C5.45001 4.13515 7.25643 2.30005 9.50001 2.30005C11.7436 2.30005 13.55 4.13515 13.55 6.41433V7.10005M5.45001 7.10005C4.70751 7.10005 4.10001 7.71719 4.10001 8.47148V15.3286C4.10001 16.0829 4.70751 16.7 5.45001 16.7H13.55C14.2925 16.7 14.9 16.0829 14.9 15.3286V8.47148C14.9 7.71719 14.2925 7.10005 13.55 7.10005M5.45001 7.10005H13.55M9.50001 12.65V10.85"
      strokeWidth={1.4}
      strokeLinecap="round"
    />
  </svg>
);

/* =========================
   Component
========================= */

const FeaturedArticles: React.FC<FeaturedArticlesProps> = ({
  featuredPosts,
}) => {
  console.log("FeaturedPosts in FeaturedArticles component:", featuredPosts);
  return (
    <section
      className="featured-feed-container"
      style={{
        color: "var(--foreground)",
      }}
    >
      <div className="featured-posts-wrapper">
        <h2 className="tag-section-title">Featured Articles</h2>

        <div className="featured-feed">
          <div className="row g-4">
            {Array.isArray(featuredPosts) &&
              featuredPosts.map((item) => (
                <div
                  className="col-12 col-md-6 col-lg-3 card-container"
                  key={item.id}
                >
                  <CommonCard
                    bodyClassName="px-0"
                    authorName={item.author}
                    publishDate={item.date}
                    titleText={item.title}
                    imgSrc={item.image || "/image-not-found.png"}
                    cardLink={`/${item.url}`}
                    titleClassName="post-card-text section-card px-0"
                    // imageWrapperClassName="post-card-image"
                    category_name={item.category_name || ""}
                    category_slug={item.category_slug || ""}
                    category_color={item.category_color || ""}
                    sub_category_name={item.sub_category_name || ""}
                    sub_category_slug={item.sub_category_slug || ""}
                    sub_category_color={item.sub_category_color || ""}
                    authorSlug={`${item.author_slug}` || ""}
                    authorSlugClassName="authors-slug"
                  />
                </div>
              ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturedArticles;
